module.exports = __webpack_public_path__ + "static/assets/c097e105f9d0503db874d7b74b067828.svg";